export default "__VITE_ASSET__J22FaKJz__"